import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";
import LoadingButton from "../../components/LoadingButton";

export default ({
  open,
  onClose,
  onSave,
  loading = false,
  existingNames = [],
}: {
  open: boolean;
  onClose: () => void;
  onSave: (name: string) => Promise<void>;
  loading?: boolean;
  existingNames?: string[];
}) => {
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  // Reset state when dialog opens
  useEffect(() => {
    if (open) {
      setName("");
      setError("");
    }
  }, [open]);

  // Validate name against existing names
  useEffect(() => {
    if (name.trim()) {
      const normalizedName = name.trim().toLowerCase();
      const isDuplicate = existingNames.some(
        (existingName) => existingName.toLowerCase() === normalizedName
      );
      if (isDuplicate) {
        setError("A column or action with this name already exists");
      } else {
        setError("");
      }
    } else {
      setError("");
    }
  }, [name, existingNames]);

  const handleSave = async () => {
    if (name.trim() && !error) {
      await onSave(name);
      setName("");
    }
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Add Column
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          sx={{ my: 2 }}
          fullWidth
          label="Column Name"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          error={!!error}
          helperText={error}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <LoadingButton
          variant="contained"
          loading={loading}
          disabled={name === "" || !!error}
          onClick={handleSave}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
